import { cn } from '@/lib/utils';
import PlayerlistSummary from './PlayerlistSummary';
import Playerlist from './Playerlist';


type PlayerSidebarProps = {
    isSheet?: boolean;
};
export function PlayerlistSidebar({ isSheet }: PlayerSidebarProps) {
    return (
        <aside className={cn('fc-rail', isSheet ? 'sheet' : 'tx-sidebar hidden xl:flex')}>
            <PlayerlistSummary />
            <div className="fc-rail-list">
                <Playerlist />
            </div>
        </aside>
    );
}
